"use client";
import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";

export function AuthNav() {
  const router = useRouter();
  return (
    <div className="flex content-center flex-wrap">
      <button onClick={() => signIn()} className="hover:underline mr-5">
        Login
      </button>
      <button
        onClick={() => router.replace("/signup")}
        className="hover:underline px-3 py-2 bg-white text-[#2d5ad0] rounded-md"
      >
        Sign up
      </button>
    </div>
  );
}
